import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles<Theme>((theme) => ({
  titleStyle: {
    marginBottom: theme.spacing(2),
  },
}));

export default useStyles;
